var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpcClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6658_528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.48438 13.3276C1.48438 7.4351 1.48437 4.4888 3.31496 2.65822C5.14554 0.827636 8.09179 0.827637 13.9844 0.827637C19.8769 0.827637 22.8232 0.827636 24.6537 2.65822C26.4844 4.4888 26.4844 7.4351 26.4844 13.3276C26.4844 19.2201 26.4844 22.1665 24.6537 23.997C22.8232 25.8276 19.8769 25.8276 13.9844 25.8276C8.09179 25.8276 5.14554 25.8276 3.31496 23.997C1.48437 22.1665 1.48438 19.2201 1.48438 13.3276Z",
    stroke: "#EA7F4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9844 8.32764V13.3276L17.1094 16.4526",
    stroke: "#EA7F4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6658_528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpcClock);
export default __webpack_public_path__ + "static/media/cpc-clock.9f872ba15f50de8214ceda53307c96e7.svg";
export { ForwardRef as ReactComponent };